export default __webpack_public_path__ + "static/media/polygon_inactive.2f0108ca.svg";